import React, {Component} from 'react';
import {Redirect} from "react-router-dom";
import './Authenticate.css';
import axios from "axios";
import {RESOURCE_BASE_URL, BASE_URL} from "../../../configuration";
import InitialQuotationState from "../../Site/QuotationForm/InitialQuotationState";

class Authenticate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false
        };
    }

    componentDidMount() {
        console.log("user data ===> " + this.props.userId)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        // if (prevProps.keycloak !== this.props.keycloak && this.props.keycloak != null) {
        //     this.registerUser(this.props.keycloak.subject, this.props.roles);
        //
        // }
        // this.setState({redirect: true});
    }

    checkAdmin = () => {
        if(this.props.getUserRole !== undefined && this.props.userData != null){
            this.props.getUserRole(this.props.userData.payload.userName);
            // this.props.getLoggedUser(this.props.keycloak.subject);
        }
    };

    registerUser = (id, roles) => {
       if(id !== null){
           let axiosConfig = {
               headers: {
                   'Content-Type': 'application/json;charset=UTF-8',
                   "Access-Control-Allow-Origin": "*",
               }
           };
           axios.post(RESOURCE_BASE_URL + 'api/users/register'
               , {
                   userId: id,
                   roles : roles,
                   isAdmin : this.props.isAdmin === true ? "admin" : "false"
               }, axiosConfig)
               .then((res) => {
                   if( InitialQuotationState.naviUserName==="" || InitialQuotationState.naviUserName===null){
                       InitialQuotationState.naviUserName = res.data.username;

                   }
                   // InitialQuotationState.naviUserName = res.data.username;
                   this.setState({redirect: true}, ()=>this.checkAdmin());
               })
               .catch((err) => {
                   this.setState({redirect: true}, ()=>this.checkAdmin());
                   console.log("[API] ERROR: ", err);
               });
       }

    };

    render() {
        return(
            <div>
                {/*{(this.state.redirect) ? <Redirect to="/" /> : <div></div>}*/}
            </div>
        )
    }
}

export default Authenticate;



// WEBPACK FOOTER //
// ./src/components/Common/Authenticate/Authenticate.js